import { h, Component } from 'preact';
// import Store from 'store/store';
import { joinClasses, parseDate } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';

import s from 'components/theaterInfo/theaterInfo.scss';

export default class TheaterInfo extends Component {
	render(props) {
		const { mini, theater, movie, screening } = props;

		const addressParts = theater?.address;

		const address = [
			addressParts?.street,
			addressParts?.city,
			addressParts?.state == 'IR' ? 'IE' : addressParts?.state,
			addressParts?.postcode,
		].filter(e => e).join(', ');

		let dateTime;
		if (screening?.date && screening?.time) {
			dateTime = formatDateTime(parseDate(`${screening.date} ${screening.time}`), 'dddd, MMMM dd - h:mmtt');
		}

		return (
			<div class={joinClasses(s.root, mini && s.mini, props.class)}>
				<div class={s.theater}>
					<div class={s.name}>{theater?.name}</div>
					<div class={s.address}>{address}</div>
				</div>
				<div class={s.separator} />
				<div class={s.screening}>
					<div class={s.movie}>{movie?.title}</div>
					<div class={s.time}>{dateTime}</div>
					{/* <div class={s.screen}>{screening?.screen}</div> */}
				</div>
			</div>
		);
	}
}